export default "__VITE_ASSET__BdjwZUKT__"